import React, { useCallback } from 'react';
import { AdminDeleteEventModalProps } from './admin-delete-event-modal-props';
import { AdminModal } from '../admin-modal';
import { AdminModalBody } from '../admin-modal-body';
import { AdminModalButtonFooter } from '../admin-modal-button-footer';
import { AdminModalHeader } from '../admin-modal-header';
import { AdminModalHeading } from '../admin-modal-heading';
import { AdminModalText } from '../admin-modal-text';
import { Button } from '@mint/ui';
import { popAdminModal } from '../../../actions';
import { useDeleteEventMutation } from '../../../mutations';
import { useDispatch } from 'react-redux';

export const AdminDeleteEventModal: React.FunctionComponent<
  AdminDeleteEventModalProps
> = props => {
  const dispatch = useDispatch();

  const [deleteEvent] = useDeleteEventMutation({
    id: props.eventId,
  });

  const onDeleteClick = useCallback(async () => {
    await deleteEvent();
    dispatch(popAdminModal());
  }, [deleteEvent]);

  const onCancelClick = useCallback(() => {
    dispatch(popAdminModal());
  }, [dispatch]);

  return (
    <AdminModal>
      <AdminModalHeader>
        <AdminModalHeading>Delete Event</AdminModalHeading>
      </AdminModalHeader>
      <AdminModalBody>
        <AdminModalText>
          {props.eventName ? (
            <>
              Are you sure you want to delete the event <b>{props.eventName}</b>
              ?
            </>
          ) : (
            'Are you sure you want to delete this event?'
          )}
        </AdminModalText>
      </AdminModalBody>
      <AdminModalButtonFooter>
        <Button onClick={onCancelClick}>Cancel</Button>
        <Button onClick={onDeleteClick} color="error">
          Yes, Delete Forever
        </Button>
      </AdminModalButtonFooter>
    </AdminModal>
  );
};
